.container {
    display: flex;
    align-items: flex-end;
    gap: 4px;
    width: 100%;
    justify-self: flex-end;
}

.container--outbound {
    composes: container;
    flex-direction: row-reverse;
}

.container--with-edition {
    composes: container;
    align-items: flex-start;
}

.empty-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: var(--white);
}
